export function initMobileSearch() {
	const formContainer = document.querySelector(
		'.gmeta-posw0lo'
	) as HTMLElement;
	const searchForm = document.querySelector(
		'.gmeta-posw0lo > .search-form'
	) as HTMLElement;
	const toggleButton = document.getElementById(
		'search-form-toggle'
	) as HTMLElement;
	let isOpen = false;

	initWrapperWidth();

	const handleOpenedClasses = () => {
		if ( isOpen ) {
			formContainer.classList.add( 'gmeta-posw0lo--opened' );
			document.body.classList.add( 'gmeta-posw0lo--opened' );
			toggleButton.classList.remove( 'bb-icon-search' );
			toggleButton.classList.add( 'bb-icon-times' );
		} else {
			formContainer.classList.remove( 'gmeta-posw0lo--opened' );
			document.body.classList.remove( 'gmeta-posw0lo--opened' );
			toggleButton.classList.add( 'bb-icon-search' );
			toggleButton.classList.remove( 'bb-icon-times' );
		}
	};
	const showSearchForm = ( shouldShow ) => {
		isOpen = shouldShow;
		handleOpenedClasses();
	};
	document.addEventListener( 'click', ( e: any ) => {
		if ( e.gmetaHeaderHandled ) {
			return;
		}

		if ( ! isOpen ) {
			return;
		}

		const shouldClose =
			Boolean( e.target.closest( '#search-form-toggle' ) ) ||
			! e.target.closest( '.gmeta-posw0lo > .search-form' );

		if ( shouldClose ) {
			showSearchForm( false );
		}
	} );
	toggleButton.addEventListener( 'click', ( e: any ) => {
		showSearchForm( ! isOpen );
		e.gmetaHeaderHandled = true;
	} );
}

function initWrapperWidth() {
	const wrapper = document.querySelector(
		'.header-mobile__wrapper'
	) as HTMLElement;
	const width = wrapper.getBoundingClientRect().width;
	document.body.style.setProperty(
		'--header-mobile-wrapper-width',
		`${ width }px`
	);

	const observer = new ResizeObserver( ( entries ) => {
		for ( const entry of entries ) {
			document.body.style.setProperty(
				'--header-mobile-wrapper-width',
				`${ entry.contentRect.width }px`
			);
		}
	} );

	observer.observe( wrapper );
}
